import {
  VITE_REACT_APP_LOG_CONSOLE_ENABLED,
  VITE_REACT_APP_LOG_LEVEL,
  VITE_REACT_APP_LOG_NETWORK_ENABLED,
  VITE_REACT_APP_MELA_ENV,
} from "../../constants/variables";
import { ConsoleTransport } from "./ConsoleTransport";
import { Logger } from "./Logger";
import { LogLevel } from "./LoggerTypes";
import { NetworkTransport } from "./NetworkTransport";

const generateDeviceId = () => {
  const existingToken = localStorage.getItem("deviceId");
  if (existingToken) {
    return existingToken;
  }
  const newToken =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);
  localStorage.setItem("deviceId", newToken);
  return newToken;
};

const getDeviceInfo = () => navigator?.userAgent || "unknown";

const logLevel = LogLevel.fromString(
  (VITE_REACT_APP_LOG_LEVEL as any) || "LOG",
);
const transports = [];
if (VITE_REACT_APP_LOG_CONSOLE_ENABLED === "true") {
  transports.push(new ConsoleTransport(console, false));
}
if (VITE_REACT_APP_LOG_NETWORK_ENABLED !== "false") {
  transports.push(new NetworkTransport());
}
const deviceInfo = getDeviceInfo();
const family = "portal";
const env = VITE_REACT_APP_MELA_ENV || "local";
const deviceId = generateDeviceId();
const logger = new Logger({
  configLevel: logLevel,
  transports,
  deviceInfo,
  family,
  env,
  deviceId,
});
export default logger;
